import { render } from "./ViewCompetitionsView.vue?vue&type=template&id=5061eb3a&scoped=true&ts=true"
import script from "./ViewCompetitionsView.vue?vue&type=script&lang=ts"
export * from "./ViewCompetitionsView.vue?vue&type=script&lang=ts"

import "./ViewCompetitionsView.vue?vue&type=style&index=0&id=5061eb3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5061eb3a"]])

export default __exports__